<div class="page-header">
  <h1>Dashboard opérations techniques</h1>
</div>

<div class="page-body">
  @if (error) {
  <div class="error-banner">
    <em class="fal fa-exclamation-triangle"></em>
    <div>
      <strong>Erreur</strong>
      <pre>{{ error | json }}</pre>
    </div>
  </div>
  }

  <div class="action-grid">
    <div class="card action-card">
      <div class="action-card-icon"><em class="fal fa-paper-plane"></em></div>
      <div class="action-card-body">
        <h2 class="action-card-title">Envoi d'un mail de test</h2>
      </div>
      <button (click)="sendMail()" class="btn btn-light action-btn" type="button">
        Envoi mail test
      </button>
    </div>

    <div class="card action-card">
      <div class="action-card-icon"><em class="fal fa-broom"></em></div>
      <div class="action-card-body">
        <h2 class="action-card-title">Vider les caches Ecawin</h2>
      </div>
      <button (click)="clearEcawinCaches()" class="btn btn-light action-btn" type="button">
        Vider
      </button>
    </div>

    <div class="card action-card">
      <div class="action-card-icon"><em class="fal fa-address-book"></em></div>
      <div class="action-card-body">
        <h2 class="action-card-title">LDAP</h2>
      </div>
      <div class="action-card-buttons">
        <button
          type="button"
          [ngClass]="ldap ? 'btn-dark' : 'btn-outline-danger'"
          class="btn action-btn"
          (click)="toggleLdap()"
        >
          @if (ldap) {
          <span><em class="fal fa-check"></em> LDAP activé</span>
          } @else {
          <span><em class="fal fa-ban"></em> LDAP désactivé</span>
          }
        </button>

        <button (click)="testLdap()" class="btn btn-light action-btn" type="button">
          Test LDAP
        </button>
      </div>
    </div>

    <div class="card action-card">
      <div class="action-card-icon"><em class="fal fa-shield-check"></em></div>
      <div class="action-card-body">
        <h2 class="action-card-title">Recaptcha</h2>
      </div>
      <button
        type="button"
        [ngClass]="recaptcha ? 'btn-dark' : 'btn-outline-danger'"
        class="btn btn-light action-btn"
        (click)="toggleRecaptcha()"
      >
        @if (recaptcha) {
        <span><em class="fal fa-check"></em> Recaptcha activé</span>
        } @else {
        <span><em class="fal fa-ban"></em> Recaptcha désactivé</span>
        }
      </button>
    </div>
  </div>

  <div class="section">
    <h2 class="section-title">Messages broadcast</h2>

    <div class="broadcast-preview">
      <mir-sqrs-broadcast></mir-sqrs-broadcast>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-hover messages-table">
        <thead>
          <tr>
            <th>SDIS</th>
            <th>Login only</th>
            <th>Sujet</th>
            <th>Message</th>
            <th>Date</th>
            <th>Fichier</th>
            <th>Criticité</th>
            <th>Icône</th>
            <th class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (msg of messages; track msg) {
          <tr>
            <td>{{ msg.sdis }}</td>
            <td>{{ msg.loginOnly }}</td>
            <td>{{ msg.subject }}</td>
            <td>{{ msg.body }}</td>
            <td>{{ msg.dateFrom }}</td>
            <td>{{ msg.filename }}</td>
            <td>
              <span [ngClass]="'criticity-chip--' + msg.criticity" class="badge rounded-pill criticity-chip">{{ msg.criticity }}</span>
            </td>
            <td><em class="fal fa-2x" [ngClass]="msg.icon"></em></td>
            <td>
              <div class="row-actions">
                <button
                  type="button"
                  class="btn btn-light btn-icon"
                  tooltip="Modifier"
                  (click)="showEditModal(msg)"
                >
                  <em class="fal fa-pencil"></em>
                </button>
                <button
                  type="button"
                  [ngClass]="
                    msg.filename.endsWith('.disabled')
                      ? 'btn-outline-danger'
                      : 'btn-outline-success'"
                  [tooltip]="
                    msg.filename.endsWith('.disabled')
                      ? 'Activer'
                      : 'Désactiver'"
                  class="btn btn-light btn-icon"
                  (click)="toggleMessage(msg)"
                >
                  <em
                    class="far"
                    [ngClass]="
                      msg.filename.endsWith('.disabled')
                        ? 'fa-toggle-off'
                        : 'fa-toggle-on'"
                  ></em>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
